export enum TipoCredor {
  Fisica = 0,
  Juridica = 1
}

export const TipoCredorLabel = new Map<TipoCredor, string>([
  [TipoCredor.Fisica, "Fisica"],
  [TipoCredor.Juridica, "Juridica"],
]);
